import { Component, Input, ViewEncapsulation } from '@angular/core';
import { CommonNgModule } from '../../../shared/modules/common-ng/common-ng.module';

@Component({
  selector: 'app-list-item',
  standalone: true,
  imports: [
    CommonNgModule
  ],
  templateUrl: './list-item.component.html',
  styleUrl: './list-item.component.scss',
  encapsulation: ViewEncapsulation.None
})
export class ListItemComponent {
  @Input() Theme:any;

  constructor() { }

  ngOnInit() {
  }
}
